import React, { useState, useEffect } from 'react';
import { cloneDeep, isEmpty, set } from 'lodash';
import { useTranslation } from 'react-i18next';
import SwitchInput from './SwitchInput';
import { MultipleSectionCheckBox } from './MultipleSectionCheckBox';
import RowCheckBox from './RowCheckBox';
import { UserAccessRights } from '../../../Components/helper';
import { LIBRARY_APPROVE_MODULES } from '../store/rightsArray';

function UserRightSection({ rightSectionData, data }) {
  const [showData, setShowData] = useState([]);
  const rights = UserAccessRights();
  const { t } = useTranslation('common');

  useEffect(() => {
    if (data?.rights && !isEmpty(data?.rights)) {
      const right = [];
      for (const rights of Object.entries(data?.rights)) {
        right.push({
          name: rights[0],
          rightsArray: rights[1],
          switchstatus: true,
          expandData: true,
        });
      }
      setShowData(right);
    }
  }, [data]);

  useEffect(() => {
    if (showData?.length > 0) {
      rightSectionData(showData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showData]);

  const handleSelectAll = (e, items) => {
    const clonedData = cloneDeep(showData);
    const { name } = e.target;
    let updatedValues;
    if (name === 'approveReject' && items?.[0]?.section?.label === 'Libraries/Groups/Templates') {
      updatedValues = items.map((ele) => {
        if (LIBRARY_APPROVE_MODULES.includes(ele?.module)) {
          ele[name] = e.target.checked;
        }
        return ele;
      });
    } else if (name === 'all') {
      updatedValues = items.map((ele) => {
        ele.all = e.target.checked;
        ele.addEdit = e.target.checked;
        ele.delete = e.target.checked;
        ele.approveReject = e.target.checked;
        return ele;
      });
    } else {
      if (!e.target.checked) {
        updatedValues = items.map((ele) => {
          ele.all = e.target.checked;
          ele[name] = e.target.checked;
          return ele;
        });
      }
      updatedValues = items.map((ele) => {
        ele[name] = e.target.checked;
        return ele;
      });
    }
    const parentIndex = clonedData.findIndex((parentEle) => {
      return parentEle?.rightsArray?.[0]?.section?.label === updatedValues?.[0]?.section?.label;
    });

    clonedData[parentIndex].rightsArray = updatedValues;
    setShowData([...clonedData]);
  };

  const onChangeCheckbox = async (e, parentElement, module) => {
    const clonedData = cloneDeep(showData);
    const nameSplit = e?.target?.name?.split('_');
    const path = nameSplit.join('.');

    let updatedData;
    let updatedApproveRejectPath;
    if (nameSplit.includes('all')) {
      const addEditPath = path.replace('all', 'addEdit');
      const updateAddEdit = set(clonedData, addEditPath, e?.target?.checked);

      const deletePath = path.replace('all', 'delete');
      const updateDeletePath = set(updateAddEdit, deletePath, e?.target?.checked);

      // conditionally added true/false to approve reject check box
      const appRejPath = path.replace('all', 'approveReject');
      if (parentElement?.name === 'products' || (parentElement?.name === 'libraries' && LIBRARY_APPROVE_MODULES.includes(module))) {
        updatedApproveRejectPath = set(updateDeletePath, appRejPath, e?.target?.checked);
      } else {
        updatedApproveRejectPath = set(updateDeletePath, appRejPath, false);
      }
      updatedData = set(updatedApproveRejectPath, path, e?.target?.checked);
    } else {
      const newData = set(clonedData, path, e?.target?.checked);
      if (!e.target.checked) {
        const allPath = path.replace(/addEdit|delete|approveReject/g, 'all');
        updatedData = set(newData, allPath, e?.target?.checked);
      } else {
        updatedData = set(clonedData, path, e?.target?.checked);
      }
    }

    const rightsArray = updatedData[nameSplit[0]]?.rightsArray;
    const rightsArrayLength = rightsArray.length;
    let truno = 0;
    let falseno = 0;
    rightsArray?.forEach((na) => {
      if (na.switchstatus) {
        truno += 1;
      } else falseno += 1;
    });
    if (truno > 0 && truno === 1) {
      const ck = rightsArray?.map((ele) => {
        ele.section.switchStatus = true;
        return ele;
      });
      updatedData[nameSplit[0]].rightsArray = ck;
    }
    if (falseno === rightsArrayLength) {
      const ck = rightsArray?.map((ele) => {
        ele.section.switchStatus = false;
        return ele;
      });
      updatedData[nameSplit[0]].rightsArray = ck;
    }
    setShowData([...updatedData]);
  };

  const btnCall = (ele) => {
    return ele?.expandData === false ? <i className="icon-new-up" /> : <i className="icon-new-down" />;
  };

  const callApi = async (ele) => {
    const foundElement = showData.findIndex((dataEle) => dataEle?.name === ele?.name);
    const clonedElements = cloneDeep(showData);
    if (foundElement !== -1) {
      clonedElements[foundElement].expandData = !ele.expandData;
      setShowData([...clonedElements]);
    }
  };

  const switchHandler = (item, value) => {
    const clonedEle = cloneDeep(showData);
    const fIndex = clonedEle.findIndex((cEle) => cEle?.name === item?.name);
    const right = cloneDeep(clonedEle[fIndex].rightsArray);
    clonedEle[fIndex].switchstatus = value;
    const updatedArray = right?.map((ele) => {
      ele.switchstatus = value;
      ele.section.switchStatus = value;
      return ele;
    });
    if (fIndex !== -1) {
      clonedEle[fIndex].rightsArray = updatedArray;
      setShowData([...clonedEle]);
    }
  };

  return (
    <div className="full-width-block">
      <div className="table-responsive table-max-h-60 pb-2 mt-3 pb-4">
        <table className="table custom-table font-13 mt-4">
          <thead>
            <tr>
              <th style={{ width: '25%' }} height="43">
                {t('USER_RIGHT_SECTION.RIGHTS_MANAGEMENT')}
              </th>
              <th>{t('USER_RIGHT_SECTION.ALL')}</th>
              <th>{t('USER_RIGHT_SECTION.ADD_EDIT')}</th>
              <th>{t('USER_RIGHT_SECTION.DELETE')}</th>
              <th>{t('USER_RIGHT_SECTION.READ_ONLY')}</th>
              <th>{t('USER_RIGHT_SECTION.APPROVE_REJECT')}</th>
            </tr>
          </thead>
          <tbody>
            {/** *****first Products******* */}
            {!isEmpty(showData) &&
              showData.map((element, pIndex) => {
                if (!rights[element?.name]) return null;
                return (
                  <>
                    <tr>
                      <td
                        colSpan="6"
                        style={{
                          padding: '0%',
                          border: 'none',
                          background: '#cecece',
                        }}
                      >
                        <div className="title-container d-flex align-items-center" style={{ border: 'none' }}>
                          <SwitchInput switchHandler={switchHandler} item={element} index={pIndex} />
                          <button type="button" className="btn ml-auto" onClick={() => callApi(element)}>
                            {btnCall(element)}
                          </button>
                        </div>
                      </td>
                    </tr>
                    <MultipleSectionCheckBox handleSelectAll={handleSelectAll} items={element?.rightsArray} parentElement={element} />
                    {element?.expandData &&
                      element?.rightsArray?.map((items, index) => {
                        if (!rights[items?.module]) return null;
                        return (
                          <tr key={`${items?.section?.label}_${items._id}`}>
                            <RowCheckBox
                              item={items}
                              index={index}
                              parentElement={element}
                              parentIndex={pIndex}
                              onChangeCheckbox={(e) => {
                                onChangeCheckbox(e, element, items?.module);
                              }}
                            />
                          </tr>
                        );
                      })}
                  </>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UserRightSection;
